{
    "54Ft8": {
        "position": {
            "x": 7,
            "y": 6,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "54Ft8"
    },
    "ashe": {
        "position": {
            "x": 7,
            "y": 7,
            "z": 1
        },
        "templateKey": "player/book/ashe",
        "key": "ashe"
    },
    "Xos7g": {
        "position": {
            "x": 7,
            "y": 4,
            "z": 1
        },
        "templateKey": "jobs/book/eyebeast",
        "jobKey": "book/eyebeast",
        "key": "Xos7g",
        "previousMultiselect": [
            "Xos7g",
            "Xos7g"
        ]
    },
    "page": {
        "key": "page",
        "role": "page",
        "spriteSize": "contained", "imageKey": "book/page2",
        "type": "zone",
        "properties": [
            "no healthbar"
        ],

        "position": {
            "x": 7,
            "y": 3,
            "z": 1
        },
        "pageKeys": [
            "angel"
        ]
    }
}
